import React from 'react'
import Icon from 'components/icon/icon'
import moment from 'moment'

import Button from 'components/button/button'

export default ({
    changeDay,
    canChange,
    pageIndex,
    paginateType,
    dates,
    buttons
}) => {
    const getDateString = () => {
        return moment(dates.start).isSame(moment(dates.end), 'month') ? `${moment(dates.start).format('Do')} - ${moment(dates.end).format('Do MMMM')}` : `${moment(dates.start).format('Do MMMM')} - ${moment(dates.end).format('Do MMMM')}`
    }

    const getTitleString = _ => {
        let title = ''

        if (!pageIndex) {
            title = `This ${paginateType}`
        } else if (pageIndex == 1) {
            title = `Last ${paginateType}`
        } else if (pageIndex == -1) {
            title = `Next ${paginateType}`
        } else if (pageIndex < 0) {
            title = `${Math.abs(pageIndex)} ${paginateType}s from now`
        } else {
            title = `${pageIndex} ${paginateType}s ago`
        }

        return title
    }

    return (
        <div className="heading week-nav">
            <h4>
                {getTitleString()}
                <em>
                    ({getDateString()})
                    </em>
                <div className="header-tab-controls has-today">
                    <button
                        className={canChange.back ? 'active' : null}
                        onClick={_ => { changeDay('prev', canChange.back) }}
                    >
                        <Icon name="angle-left" />
                        <span>
                            Back
                        </span>
                    </button>
                    <button
                        className={pageIndex !== 0 ? 'active' : null}
                        onClick={_ => { changeDay('today', pageIndex !== 0) }}
                    >
                        <span>
                            Today
                        </span>
                    </button>
                    <button
                        className={canChange.forward ? 'active' : null}
                        onClick={_ => { changeDay('next', canChange.forward) }}
                    >
                        <span>
                            Forward
                        </span>
                        <Icon name="angle-right" />
                    </button>
                </div>
            </h4>
            {(buttons && buttons.length) ?
                <ul className={`button-shelf`}>
                    {buttons.map((buttonProps, index) => {
                        return (
                            <li key={index} className="tooltip-trigger">
                                <Button {...buttonProps} />
                                {
                                    buttonProps.tooltip ?
                                        <div className="tooltip">
                                            {buttonProps.tooltip}
                                        </div>
                                        : null
                                }
                            </li>
                        )
                    })}
                </ul>
                : null}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/week-nav/week-nav.jsx